import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Loader } from "../components/Loader";
import API from "../helper/AxiosInterceptor";

const Faq = () => {
  const [openAccordion, setOpenAccordion] = useState(0);
  const [faqData, setFaqData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPages = async () => {
    try {
      setIsLoading(true);
      const response = await API.get(
        `${process.env.REACT_APP_API_URL}/faq/list`
      )
        .then((res) => {
          console.log("res", res);
          setFaqData(res?.data?.data);
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.error("Error fetching pages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPages();
  }, []);

  const handleAccordionClick = (index) => {
    setOpenAccordion(index === openAccordion ? -1 : index); // Toggle accordion open/close
  };

  if (isLoading) {
    return <Loader />;
  }

  console.log("faqData", faqData);

  return (
    <>
      <Header />
      <div className="site-bg">
        <section className="inner-page-head">
          <div className="container">
            <h1>Support &amp; Help (FAQ)</h1>
            <ul>
              <li className="home">
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/faq">&rarr; Support &amp; Help (FAQ)</Link>
              </li>
            </ul>
          </div>
        </section>
   

        <section className="support-help-bg section-padding light-bg">
          <div className="container">
            <div className="accordion" id="accordionExample">
              {faqData.map((item, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header" id={`heading${index}`}>
                    <button
                      className={`accordion-button ${
                        openAccordion === index ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => handleAccordionClick(index)}
                      aria-expanded={openAccordion === index ? "true" : "false"}
                      aria-controls={`collapse${index}`}
                    >
                      {item?.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${
                      openAccordion === index ? "show" : ""
                    }`}
                    aria-labelledby={`heading${index}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>{item?.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Faq;
